module.exports = __webpack_public_path__ + "static/media/keyman-db-banner-bg.8465a5df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyman-db-banner-bg.png
// module id = 1286
// module chunks = 1